import { render, staticRenderFns } from "./AMenuItem.vue?vue&type=template&id=21878072&"
import script from "./AMenuItem.vue?vue&type=script&lang=js&"
export * from "./AMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./AMenuItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports